export default class Any {
  constructor() {
    this.type = null
    this.format = `any`
  }
}
